import React, { type FC, memo, useCallback } from 'react';
import { useDuplicatesAnalytic } from 'reactApp/hooks/duplicates/useDuplicatesAnalytic';
import { openDuplicatesRemoveGroupModal } from 'reactApp/ui/Duplicates/DuplicatesRemoveGroupModal/DuplicatesRemoveGroupModal.helpers';
import { sendXray } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './RemoveGroupButton.css';

interface IProps {
    groupId?: string;
}

export const RemoveGroupButton: FC<IProps> = memo(function RemoveGroupButton(props) {
    const { groupId } = props;

    const analyticData = useDuplicatesAnalytic();

    const onClick = useCallback(() => {
        if (!groupId) {
            return;
        }

        sendXray(['dp-btn-clear-group-click']);

        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'button_click',
            type_button: 'leave_best',
            ...analyticData,
        });

        openDuplicatesRemoveGroupModal(groupId);
    }, [analyticData, groupId]);

    return (
        <span className={styles.root} data-qa-id="remove-duplicates-group-button" data-qa-duplicates-group-id={groupId} onClick={onClick}>
            Оставить лучший
        </span>
    );
});
